import styled from '@emotion/styled'

export const InvoiceSettingsColumnWrapper = styled.div`
  position: relative;
`
